import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		background: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			maxWidth: '100%',
			overflow: 'hidden',
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ metaData }) => metaData.mobileOpacity?.toNumber() / 100,
			},
		},
		title: {
			marginBottom: theme.spacing(3.4),
		},
		text: {
			marginBottom: theme.spacing(3.75),
		},
		image: {
			'& picture': {
				display: 'flex',
				justifyContent: 'center',
			},
			'& img': {
				objectPosition: 'center',
				objectFit: 'contain',
			},
		},
		centredImage: {
			'& picture': {
				maxHeight: theme.spacing(36.25),
			},
			marginBottom: theme.spacing(3),
		},
		empty: {
			display: 'none',

			[theme.breakpoints.up('sm')]: {
				display: 'block',
			},
		},

		buttonWrap: {
			display: 'flex',
			justifyContent: 'start',

			[theme.breakpoints.down('xs')]: {
				justifyContent: 'center',
			},
		},
		button: {
			minWidth: theme.spacing(32.75),

			[theme.breakpoints.down('xs')]: {
				minWidth: 'auto',
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},
		},
	}),
	{ name: 'Content-Content2' },
)

export default useStyles
